import React from 'react';
import { StopCircle } from 'feather-icons-react/build/IconComponents';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
// import { selectStatuses } from '../../core/redux/status/selectors';
import { selectQualityAlertFilters } from './store/selectors';
import { actions as QualityAlertActions, fetchQualityAlertWithFilters } from './store/slice';
import { Link } from 'react-router-dom';
import { useTransformOptions } from 'Core/hooks';
import { selectProcessStatuses } from '../../core/redux/status/selectors';
const { setStatus} = QualityAlertActions;

const QualityAlertFilter = () => {
  const dispatch = useDispatch();
 const statuses = useSelector(selectProcessStatuses);
  const {
    status: selectedStatus,
  } = useSelector(selectQualityAlertFilters);

const statusOptions = useTransformOptions(statuses || [], 'status', 'status', '', 'Select Status');

  const handleStatusChange = selected => {
    dispatch(setStatus(selected));
  };

  const onSearch = () => {
    dispatch(fetchQualityAlertWithFilters());
  };

  return (
    <div className="card visible" id="filter_inputs" style={{ display: 'block' }}>
      <div className="card-body pb-0">
        <div className="row">
        <div className="col-lg-4 col-sm-6 col-12">
            <div className="input-blocks">
              <StopCircle className="info-img" />
              <Select
                className="img-select"
                options={statusOptions}
                value={selectedStatus}
                onChange={handleStatusChange}
                classNamePrefix="react-select"
                placeholder="Choose Status"
              />
            </div>
          </div>

          <div className="col-lg-4 col-sm-6 col-12 ms-auto">
            <div className="input-blocks">
              <Link className="btn btn-filters ms-auto" onClick={onSearch}>
                {' '}
                <i data-feather="search" className="feather-search" /> Search{' '}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QualityAlertFilter;
